import React, { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../Context/GlobalContext';
import {
    BookOpenText,
    FileText,
    HeartPulse,
    IdCard,
    ListTodo,
    Plane,
    ShieldUser,
} from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { images } from '../Assets/images';
import storage from '../Assets/js/Global';
import moment from 'moment';


const ViewExportList = () => {
    const { translatedLabels, uploadedFiles, getDocumentList } =
        useContext(GlobalContext);
    const [scanID, setScanID] = useState("");
    const [scanDate, setScanDate] = useState("");

    const screenLabels = translatedLabels?.common;
    const authLabel = translatedLabels?.auth;
    const navigate = useNavigate();
    const [selectedFiles, setSelectedFiles] = useState([]);



    useEffect(() => {
        const storedScanId = storage.get("scanId");
        const storedScanDate = storage.get("scanDate");

        if (storedScanId) setScanID(storedScanId);
        if (storedScanDate) setScanDate(storedScanDate);
    }, []);

    const localScanDate = scanDate
    // ? moment(Number(scanDate) * 1000).format("DD/MM/YYYY | hh:mm A")
    // : "";

    const isGuest = storage.get("scanGuest");
    useEffect(() => {
        if (!isGuest) {
            getDocumentList();
        }
    }, [getDocumentList]);


    const MAX_SIZE_KB = 50000;

    const handleCheckboxChange = (file) => {
        if (file.file_size > MAX_SIZE_KB) {
            window.showToast("error", "File exceeds 50 MB limit");
            return;
        }
        setSelectedFiles((prev) =>
            prev.includes(file.id)
                ? prev.filter((id) => id !== file.id)
                : [...prev, file.id]
        );
    };

    const categoryStyles = {
        all: { icon: <ListTodo />, color: "bg-default" },
        id: { icon: <IdCard />, color: "bg-pink" },
        healthcare: { icon: <HeartPulse />, color: "bg-tan" },
        insurance: { icon: <ShieldUser />, color: "bg-yellow" },
        benefits: { icon: images.BenefitsIcon, color: "bg-blue" },
        travel: { icon: <Plane />, color: "bg-green" },
        education: { icon: <BookOpenText />, color: "bg-gray" },
    };

    const getCategoryStyle = (key) => {
        return (
            categoryStyles[key] || { icon: images.wellnessIcon, color: "bg-default" }
        );
    };

    const truncateMiddle = (str, maxLength = 20) => {
        if (!str) return "";
        if (str.length <= maxLength) return str;

        const half = Math.floor((maxLength - 3) / 2);
        return str.slice(0, half) + "..." + str.slice(-half);
    };

    const handleExport = () => {
        const payload = {
            scanId: scanID,
            documentIds: selectedFiles
        };

        navigate("/privacy-consent", { state: payload });
    };

    const handleExportGuest = () => {
        const payload = {
            scanId: scanID,
            guestEmail: storage.get("guestEmail")
        };
        navigate("/privacy-consent", { state: payload });
    };

    return (
        <div className='content-part'>

            <div>
                <div
                    style={{ background: '#f5f5f5' }}
                    className="card d-flex align-items-center flex-row p-2 gap-2 mb-2 position-relative cursor-pointer border-0 shadow-none"
                >

                    <div className="icon-wrapper bg-white">
                        <FileText />
                    </div>

                    <div className="w-100">
                        <h6 className="mb-1 file-name">
                            Scan-Report.pdf
                        </h6>
                        <div className="d-flex justify-content-between">
                            <div>
                                <p className="mb-0 text-muted fs-14px">
                                    {screenLabels?.date?.label_value || 'Date'}: {localScanDate}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {!isGuest ? (
                <>
                    <hr className='mt-0 mb-3'></hr>
                    <div>
                        <div className='d-flex justify-content-between mb-2 align-items-center'>

                            <h5 className='mb-0'>
                                {screenLabels?.document_export?.label_value || 'Select Document to Export'}
                            </h5>

                            <div>
                                <button className='btn btn-primary' onClick={handleExport}>{authLabel?.export?.label_value || 'Export'}</button>
                            </div>
                        </div>
                        {uploadedFiles.length > 0 ? (
                            uploadedFiles?.map((file) => {
                                const { icon, color } = getCategoryStyle(file.key);

                                return (

                                    <label key={file.id} className='w-100' htmlFor={`document-${file.id}`}>
                                        <div className="card d-flex align-items-center flex-row p-2 gap-2 mb-3 position-relative cursor-pointer">
                                            <div className={`icon-wrapper ${color}`}>
                                                {typeof icon === "string" ? (
                                                    <img
                                                        src={icon}
                                                        alt={file.key}
                                                        style={{ width: 34, height: 34 }}
                                                    />
                                                ) : (
                                                    icon
                                                )}
                                            </div>

                                            <div className="w-100">
                                                <h6 className="mb-1 file-name">
                                                    {truncateMiddle(file.fileName, 20)}
                                                </h6>
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <p className="mb-0 text-muted fs-14px">
                                                            {screenLabels?.uploaded?.label_value || "Uploaded"} :{" "}
                                                            {file.date}{" "}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="view-button">
                                                        <input
                                                            className="big-checkbox"
                                                            type="checkbox"
                                                            id={`document-${file.id}`}
                                                            checked={selectedFiles.includes(file.id)}
                                                            onChange={() => handleCheckboxChange(file)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </label>

                                );
                            })
                        ) : (
                            <p className="text-center text-muted mt-5">
                                {screenLabels?.no_docs?.label_value || "No documents available"}
                            </p>
                        )}
                    </div>
                </>
            ) : (
                <div className='d-flex justify-content-center mb-2 align-items-center'>
                    <div>
                        <button className='btn btn-primary' onClick={handleExportGuest}>{authLabel?.export?.label_value || 'Export'}</button>
                    </div>
                </div>
            )}

        </div >
    )
}

export default ViewExportList